import { Text, TypographyProps } from "@otta/design";
import { APPLY_UNAVAILABLE_MESSAGE } from "@otta/search/hooks/useApplyAvailability";

interface ApplyUnavailableProps extends TypographyProps {
  className?: string;
}

export function ApplyUnavailable(
  props: ApplyUnavailableProps
): React.ReactElement {
  return (
    <Text data-testid="apply-unavailable-message" {...props}>
      {APPLY_UNAVAILABLE_MESSAGE}
    </Text>
  );
}
